<template>
    <div class="flex flex-col h-full gap-2">
        <span class="text-lg font-medium">{{ meta.label }}</span>
        <div class="h-0 grow">
            <dx-data-grid
                ref="gridRef"
                :key-expr="meta.keyExpr"
                :data-source="dataSource"
                :allow-column-resizing="true"
                :allow-column-reordering="true"
                :column-auto-width="meta.columnAutoWidth || false"
                :column-min-width="70"
                column-resizing-mode="nextColumn"
                :focused-row-enabled="meta.focusedRowEnabled"
                :focused-row-index="0"
                :focused-row-key="meta.focusedRowKey || null"
                height="100%"
                :hover-state-enabled="true"
                :show-borders="true"
                :show-column-lines="true"
                :show-row-lines="true"
                :column-chooser="{ enabled: true, mode: 'select' }"
                :filter-panel="{ visible: true }"
                :filter-row="{ visible: true }"
                :fixing="{ enabled: true }"
                :header-filter="{ visible: true }"
                :load-panel="{ enabled: true }"
                :scrolling="{ mode: 'virtual' }"
                :search-panel="{ visible: true, placeholder: 'Поиск...', locateInMenu: 'auto' }"
                @content-ready="contentReady"
                @focusedRowChanged="focusedRowChanged"
                @rowDblClick="selectFocusedRow"
            >
                <dx-toolbar :items="toolbarItems" />

                <dx-column
                    v-for="(item, index) in meta.columns"
                    :key="index"
                    :caption="item.caption"
                    :data-field="item.dataField"
                    :visible="item.visible"
                    :cell-template="item.cellTemplate"
                    :edit-cell-template="item.editCellTemplate"
                    :editor-options="item.editorOptions"
                    :lookup="item.lookup || null"
                    :data-type="item.dataType || 'string'"
                    :calculate-cell-value="item.calculateCellValue"
                    :calculate-display-value="item.calculateDisplayValue"
                    :width="item.width"
                    :sort-index="item.sortIndex"
                    :sort-order="item.sortOrder"
                    :validation-rules="item.validationRules"
                />
            </dx-data-grid>
        </div>
        <div class="flex justify-end">
            <span> Всего элементов: {{ totalRows }} </span>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { DxDataGrid, DxColumn, DxToolbar } from 'devextreme-vue/data-grid';

const emit = defineEmits(['dictionarySelectionChanged']);

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    dataSource: {
        type: Object,
        default: () => {},
    },
    toolbarItems: {
        type: Array,
        default: () => [],
    },
    useDefaultToolbar: {
        type: Boolean,
        default: true,
    },
});

const gridRef = ref(null);
const gridInstance = ref(null);

onMounted(() => {
    gridInstance.value = gridRef.value.instance;
});

const totalRows = ref(0);
const contentReady = () => {
    totalRows.value = gridRef.value.instance.totalCount();
};

const focusedRow = ref({});

const focusedRowChanged = event => {
    focusedRow.value = event.row;
};

const selectFocusedRow = () => {
    emit('dictionarySelectionChanged', { key: focusedRow.value.key, data: focusedRow.value.data });
};

const toolbarItems = computed(() => {
    if (props.useDefaultToolbar) {
        if (props.toolbarItems) return props.toolbarItems.concat(defaultToolbarItems);
        else return defaultToolbarItems;
    }
    return props.toolbarItems;
});

const defaultToolbarItems = [
    {
        name: 'searchPanel',
        locateInMenu: 'auto',
        location: 'after',
    },
    {
        widget: 'dxButton',
        location: 'before',
        showText: 'inMenu',
        locateInMenu: 'auto',
        options: {
            icon: 'check',
            hint: 'Выбрать',
            text: 'Выбрать',
            onClick: selectFocusedRow,
        },
    },
];

defineExpose({
    gridInstance,
});
</script>
